import { PageRef } from 'providers/page-ref';

export type TestNavigationRootPageParams = {
  param1?: string;
  param2?: string;
  param3?: string;
};

export const ITestNavigationRootPage: PageRef<TestNavigationRootPageParams, void> = {
  pageName: 'TestNavigationRootPage',
} as PageRef<TestNavigationRootPageParams, void>;
